import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { SkeletonValue } from 'modules/finance/components/FinancialWorkspace/components/SkeletonValue'

interface Props {
  loading: boolean
  count: number
}

export const Headcount = ({ loading, count }: Props) => {
  const [tooltipOpen, toggleTooltip] = useToggle()

  return (
    <Box style={{ width: '48%' }}>
      <Tooltip.Dialog
        size="small"
        paddingY="s4"
        textAlign="left"
        open={tooltipOpen}
        toggle={toggleTooltip}
        backgroundColor="grey1000"
        attachment="bottom center"
        label={i18n.t('finance.financial_workspace.employee_costs.workforce.hc_tooltip')}
      >
        <Box
          gap="s12"
          paddingTop="s12"
          paddingLeft="s16"
          paddingRight="s12"
          paddingBottom="s20"
          flexDirection="column"
          border={{
            all: {
              style: 'solid',
              width: 's1',
              color: 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs016',
          }}
        >
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Text.Normal size="200" weight="medium" caps>
              {i18n.t('finance.financial_workspace.employee_costs.workforce.hc')}
            </Text.Normal>
            <Icon.Medium icon="info-circle-line" color="grey700" />
          </Box>
          <Text.Normal size="400" weight="bold" caps>
            {loading ? <SkeletonValue width="s80" height="s24" /> : count}
          </Text.Normal>
        </Box>
      </Tooltip.Dialog>
    </Box>
  )
}
